import { axiosInstance } from './api'

import { GETAudience, POSTAudience, PUTAudience, RuleData } from 'types/audience'
import { EntityPage, Paging } from 'types/paging'

export const audienceApi = {
  create(params: POSTAudience) {
    return axiosInstance.post('audiences/create', params)
  },
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<GETAudience>>('audiences/paging', params)
  },
  getOne(id: number) {
    return axiosInstance.get<GETAudience>(`audiences/${id}`)
  },
  update(id: number, params: PUTAudience) {
    return axiosInstance.put(`audiences/${id}`, params)
  },
  delete(id: number) {
    return axiosInstance.delete(`audiences/${id}`)
  },
  getRules() {
    return axiosInstance.get<{ data: RuleData[] }>('audiences/rules')
  },
}
